import { CoreEnvironmentService, EnvironmentType  } from 'eas-core-lib';

export const coreEnvironment: CoreEnvironmentService = {
  production: false,
  systemKey: 30, // default to OFA (30) for public users since no other app has public users at the moment - kevin.low 07/29/24
  loginUrl: 'https://safeqa.ode.state.oh.us/portal/Home',
  loginTokenUrl: 'https://safeqa.ode.state.oh.us/portal/?returnUrl=https://monitoringdev.education.ohio.gov',
  apiEndpoint: 'https://edu-dev-eas-utility.azurewebsites.net/',
  logoutUrl: 'https://safeqa.ode.state.oh.us/portal/ODESafe/SignOut?url=https://monitoringdev.education.ohio.gov',
  errorPageUrl: '',
  homePageUrl: 'dashboard',
  aboutOdeUrl: '',
  ohioGovUrl: '',
  onlineServiceUrl: '',
  stateAgenciesUrl: '',
  publicLoginUrl: 'https://safeqa.ode.state.oh.us/portal/Home',
  environment: EnvironmentType.Development,
  analyticsApiEndpoint: 'https://edu-dev-eas-analytics.azurewebsites.net'
};

